	export enum TemplateSlotTypeEnum {
		TemplateSlot = 1,
		TemplateUnavailableSlot = 2
	}
